// extracted by mini-css-extract-plugin
export var active = "_1m-b";
export var activeIndicator = "_1m-6";
export var animate = "_1m-a";
export var disabled = "_1m-c";
export var flat = "_1m-1";
export var fullWidth = "_1m-3";
export var lg = "_1m-9";
export var md = "_1m-8";
export var redoButtonTabGroup = "_1m-0";
export var sm = "_1m-7";
export var tabButton = "_1m-4";
export var tabButtonsContainer = "_1m-2";
export var xs = "_1m-5";